module.exports = __webpack_public_path__ + "media/images/lb/534-fbe8a6477f854d676a76ff873d9180fe.svg";